import React from 'react';
import SIcon from './SIcon';
import { faMicrochip } from '@fortawesome/pro-solid-svg-icons';

const Icon = props => <SIcon {...props} icon={faMicrochip} fa />;

export default Icon;
